// extracted by mini-css-extract-plugin
export default {"container":"IngredientsList_container__AOpRG"};